export const identifyTenant = (user) => {
  if (!window.posthog) return;
  window.posthog.identify(String(user.id), {
    name: `${user.first_name} ${user.last_name}`.trim(),
    user_role: 'tenant',
    tenant_id: user.id,
    is_member: !!user.is_member,
    property_id: user.propertyId,
    actor_type: 'human',
  });
  window.posthog.group('property', String(user.propertyId), {});
};

export const resetTenant = () => {
  if (!window.posthog) return;
  window.posthog.reset();
};
